module.exports = __webpack_public_path__ + "img/null.165b1278.jpg";